var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderPreviousButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3089 16.6024L15.679 21.9363C16.1145 22.408 16.8401 22.408 17.2755 21.9363C17.711 21.5009 17.711 20.7753 17.2755 20.3398L12.7037 15.8041L17.2755 11.2322C17.711 10.7968 17.711 10.0712 17.2755 9.63572C16.8401 9.20028 16.1145 9.20028 15.679 9.63572L10.3089 14.9697C9.87349 15.4413 9.87349 16.1307 10.3089 16.6024ZM27 15.8041C27 19.2512 25.5849 22.3715 23.3353 24.621C21.0857 26.9069 17.9652 28.2858 14.4817 28.2858C11.0346 28.2858 7.91429 26.9069 5.66473 24.621C3.37889 22.3714 2 19.2509 2 15.8041C2 12.3207 3.37889 9.20005 5.66473 6.9505C7.91433 4.7009 11.0348 3.28577 14.4817 3.28577C17.965 3.28577 21.0857 4.7009 23.3353 6.9505C25.5848 9.2001 27 12.3206 27 15.8041Z",
    fill: "url(#paint0_linear_982_30643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_982_30643",
    x1: 27,
    y1: 15.7858,
    x2: 2,
    y2: 15.7858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414345"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderPreviousButton);
export default __webpack_public_path__ + "static/media/CalenderPreviousButton.94436e2e6ee2ce87398b23e35bde0f95.svg";
export { ForwardRef as ReactComponent };